<template>
  <div>
     <loading 
     :active.sync="loadingNetwork" 
        :is-full-page="true"
        color="grey"
        ></loading>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white" class= "pt-3">
      <v-btn
        color="primary"
        dark
        class="mb-2"
        @click="addItem()"
        round
      >Add Network</v-btn>
      <v-btn round color="primary"><v-icon>get_app</v-icon><download-excel
    :data="locationnetworks"
    :fields="exportFields"
    worksheet="export"
    :name="'Networks_'+new Date().getTime()+'.xls'">
    Export to Excel
</download-excel></v-btn>
      <!-- <v-btn color="primary" dark class="mb-2" @click="newDialog=true,basicInformation=true" round >Add Network</v-btn> -->
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    </v-toolbar>

    <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Add Network</h1>
        <v-spacer></v-spacer>
          <v-btn color="white" flat @click="close">X</v-btn>
      </v-toolbar>
      <v-card flat>
         <v-card flat >
           <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="addressinfo.name"
                    label="*Network Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="addressinfo.abbreviation"
                    label="*Network Abbreviation"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="locationNodes"
                    required
                    item-text="name"
                    item-value="id"
                    v-model="addressinfo.locationNodeId"
                    label="*Associated Network Node"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="regions"
                    required
                    item-text="name"
                    item-value="id"
                    v-model="addressinfo.regionId"
                    label="*Region"
                  ></v-autocomplete>
                </v-flex>
                <v-layout justify-center align-center wrap>
                  <v-flex xs12 sm6 md6>
                    <v-autocomplete
                      clearable
                      hide-no-data
                      flat
                      color="primary"
                      :items="networkStatus"
                      v-model="addressinfo.networkStatus"
                      label="*Network Installation Status"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-autocomplete
                      clearable
                      hide-no-data
                      flat
                      color="primary"
                      :items="backhaulTypes"
                      v-model="addressinfo.backhaulType"
                      label="*Network Backhaul Type"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      color="primary"
                      v-model="addressinfo.isMDU"
                      label="This network has Multi-Dwelling Units"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-layout>
          
          </v-card-text>
        </v-card>

        
       <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary"
          v-if="addressinfo.name&&addressinfo.abbreviation&&addressinfo.locationNodeId&&addressinfo.regionId&&addressinfo.networkStatus&&addressinfo.backhaulType"
          
           round @click="saveNew">Save</v-btn>
           <v-btn round disabled v-else>Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="generatePackagesModal" max-width="750px">
      <v-toolbar flat class="primary">
        <h1 class="headline white--text">Associated FNO Packages</h1>
      </v-toolbar>

      <v-card flat>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-combobox
                  :items="packagesFnoCats"
                  v-model="chosenFnoCats"
                  item-text="name"
                  item-value="id"
                  multiple
                  chips
                  label="Select Associated FNO Packages"
                ></v-combobox>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-combobox
                  :items="Isps"
                  v-model="chosenIsps"
                  item-text="name"
                  multiple
                  chips
                  label="Select ISP's to be on the Network"
                ></v-combobox>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  @click="generateSelectedPackages(id);"
                  round
                >Generate Packages</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-data-table :headers="fnoPackagesHeaders" :items="packageFno" item-key="packageCode">
          <template v-slot:items="props">
            <td class="justify-center layout px-0">
              <v-icon small @click="deletePackage(props.item)">delete</v-icon>
            </td>
            <td class="text-xs-center">{{props.item.packagesFno.packagesFnoCat.name}}</td>
            <td class="text-xs-center">{{props.item.packagesFno.packageCode}}</td>
            <td class="text-xs-center">{{props.item.packagesFno.packageBasePrice | currency}}</td>
          </template>
        </v-data-table>
        <template>
          <v-btn @click="close()">Save</v-btn>
        </template>
      </v-card>
    </v-dialog>

    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

    <v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="networksWithArpu"
      :rows-per-page-items="[25, 50, 100, 250]"
      item-key="name"
      align-center
      style="cursor: pointer"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-left">{{props.item.name}}</td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.abbreviation}}</td>
        <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >{{props.item.locationNode.name}}</td>
        <td
          v-if="props.item.networkStatus==='Live'"
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >
          <v-chip small :class="`Live white--text caption my-2`">Live</v-chip>
        </td>
        <td
          v-if="props.item.networkStatus==='In Progress'"
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >
          <v-chip small :class="`Progress white--text caption my-2`">In Progress</v-chip>
        </td>
        <td
          v-if="props.item.networkStatus==='Planned'"
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >
          <v-chip small :class="`planned white--text caption my-2`">Planned</v-chip>
        </td>
        <td
          v-if="props.item.networkStatus===null"
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        ></td>
         <td @click="routerLinkToDetails(props.item)" class="text-xs-center">
          {{props.item.backhaulType}}
        </td>
        <!-- <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >{{props.item.totalPlannedUnits}}</td> -->
        
        <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >{{props.item.numberOfUnits}}</td>

        <!-- <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
           v-if="props.item.totalPlannedUnits>=props.item.numberOfUnits&&props.item.numberOfUnits!=0"
        >{{Math.round((props.item.numberOfUnits/props.item.totalPlannedUnits)*100)}}%</td>
        <td
        @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
          v-else-if="props.item.numberOfUnits>props.item.totalPlannedUnits"
          >100%
          </td>
          <td
        @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
          v-else
          >
          </td> -->
        

        
      <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        >{{props.item.liveUnits}}</td>
         <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        ><span v-if="props.item.liveUnits&&props.item.numberOfUnits">{{Math.round((props.item.liveUnits/props.item.numberOfUnits)*100)}}%</span></td>
        <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        ><span v-if="props.item.arpu !== null">{{props.item.arpu | currency}}</span><span v-else>–</span></td>
        <td
          @click="routerLinkToDetails(props.item)"
          class="text-xs-center"
        ><span v-if="props.item.lastMonthArpu !== null">{{props.item.lastMonthArpu | currency}}</span><span v-else>–</span></td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
import getEstateArpu from "@/services/EstateArpu";
import format from "date-fns/format";
import VueCurrencyFilter from "vue-currency-filter";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  props: ["locationnetworks","isloading"],
  components: {
    loading: Loading
  },
  data() {
    return {    
       addressinfo: {
        id: null,
        networkStatus: "",
        name: "",
        chosenIsps: "",
        chosenFnoCats: [],
        packagesInCat: "",
        lineRentalIncluded: false,
        tvOverFibre: false,
        gtuIncluded: false,
        gtuFee:null,
        activationFee: false,
        activationFeeAmount: null,
        routerInstallationFee: false,
        routerInstallationFeeAmount: null,
        residentialLineRentalValue: 0,
        businessLineRentalValue: 0,
        residentialRouterInstallationFeeAmount: 0,
        businessRouterInstallationFeeAmount: 0,
        locationNode: "",
        locationNodeId: null,
        regionId: null,
        streetNumber: "",
        streetName: "",
        suburb: "",
        town: "",
        city: "",
        country: "",
        geoGeometryType: "",
        geoLongitude: "",
        geoLatitude: "",
        geoHightAboveGroundLevel: null,
        geoJsonId: null,
        isActive: true,
        isDeleted: false,
        isMDU: false,
        backhaulType: ""
      },
       center: { lng: -33.919473, lat: 18.427059},
      zoom: 15,
      y: "top",
      snackbar: false,
      text: "",
      editPolygon: false,
      geocoder: null,
      infoWindowContent: {},
      currentPolyData: [],
      polyData: [],
      newPolyData: [],
      polygon: null,
      key: 0,
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      myStyles: [
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
      ],
      backhaulTypes: ["Open Band Wireless", "Licensed Wireless", "Fibre", "Hybrid"],




      tag: [],  
      loadingNetwork: false,
      basicInformation: false,
      snackbar: false,
      fnoPackagesGenerated: false,
      networkId: "",
      text: "",
      y: "top",
      x: null,
      mode: "",
      address: false,
      internetPackages: false,
      count: [],
      ispOnNetwork: [],
      dataServices: false,
      generatePackagesModal: false,
      tvServices: false,
      packageBatchNumber: [],
      packageISP: [],
      Isps: [],
      packagesInCat: [],
      packageFnoCatsArrays: [],
      fnoPackages: false,
      showDetails: true,
      loading: false,
      expand: false,
      search: "",
      networkStatus: ["Planned", "In Progress", "Live"],
      dialog: false,
  exportFields: {
        'name': 'name',
        'node': 'locationNode.name',
        'abbreviation': 'abbreviation',
        'backhaulType': 'backhaulType',
        'networkStatus': 'networkStatus',
        'liveUnits': 'liveUnits',
        'numberOfLocations': 'numberOfUnits',
        'numberOfPlannedLocations': 'totalPlannedUnits',

        },
      newDialog: false,
      pagination: {},
      fnoPackagesHeaders: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Package Category",
          align: "center",
          value: "packageCat"
        },
        {
          text: "Package Code",
          align: "center",
          value: "packageCode"
        },
        {
          text: "Base Package Price",
          align: "center",
          value: "basePackagePrice"
        }
      ],
      headers: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Abbreviation",
          align: "center",
          value: "abbreviation"
        },
        {
          text: "Associated Node",
          align: "center",
          value: "locationNode.name"
        },
        {
          text: "Network Status",
          align: "center",
          value: "networkStatus"
        },
        {
          text: "Backhaul Type",
          align: "center",
          value: "backhaulType"
        },
        // {
        //   text: "Network Planned Units",
        //   align: "center",
        //   value: "totalPlannedUnits"
        // },
        {
          text: "Number of Units",
          align: "center",
          value: "numberOfUnits"
        },
        // {
        //   text: "Network Percentage Developed",
        //   align: "center",
        // },
        {
          text: "Active Service Accounts",
          align: "center",
          value: "liveUnits"
        },
        {
          text: "Active Percentage",
          align: "center",
          value: "activePercentage"
        },
        {
          text: "ARPU",
          align: "center",
          value: "arpu"
        },
        {
          text: "ARPU (Last Month)",
          align: "center",
          value: "lastMonthArpu"
        }
      ],
      locationNetworks: [],
      arpuByNetworkId: {},
      locationNodes: [],
      editedIndex: -1,
      packagesFnoCats: [],
      chosenFnoCats: "",
      selectedFnoCats: [],
      chosenIspsArray: [],
      tabs: [
        { name: "addressInformation", displayName: "Address Information" },
        { name: "installation", displayName: "Installation Information" },
        { name: "devices", displayName: "Devices" }
      ],
      chosenIsps: "",
      packagesFnoLocationNetworks: {
        fnoPackageId: "",
        locationNetworkId: ""
      },
      packageFno: [],

      id: "",
      editedItem: {
        id: null,
        networkStatus: "",
        name: "",
        chosenIsps: "",
        chosenFnoCats: [],
        packagesInCat: "",
        lineRentalIncluded: false,
        tvOverFibre: false,
        gtuIncluded: false,
        gtuFee:null,
        activationFee: false,
        activationFeeAmount: null,
        routerInstallationFee: false,
        routerInstallationFeeAmount: null,
        residentialLineRentalValue: 0,
        businessLineRentalValue: 0,
        residentialRouterInstallationFeeAmount: 0,
        businessRouterInstallationFeeAmount: 0,
        locationNode: "",
        locationNodeId: null,
        streetNumber: "",
        streetName: "",
        suburb: "",
        town: "",
        city: "",
        country: "",
        geoGeometryType: "",
        geoLongitude: "",
        geoLatitude: "",
        geoHightAboveGroundLevel: null,
        geoJsonId: null,
        isActive: true,
        isDeleted: false
      },
      defaultItem: {
        name: "",
        isActive: true,
        isDeleted: ""
      }
    };
  },

  computed: {
    networksWithArpu() {
      var self = this;
      var num = function (v) { return (typeof v === "number" && isFinite(v)) ? v : null; };
      return (this.locationnetworks || []).map(function (n) {
        var r = self.arpuByNetworkId[n.id] || {};
        return Object.assign({}, n, {
          arpu: num(r.arpu),
          lastMonthArpu: num(r.lastMonthArpu)
        });
      });
    },
    formattedDate() {
      return this.due ? format(this.due, "Do MMM YYYY") : "";
    },

    formTitle() {
      return this.editedIndex === -1 ? "Add Item" : "Edit Item";
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
 created() {
    this.initialize();
    this.fetchEstateArpu();
    
  },
  methods: {
    fetchEstateArpu() {
      var self = this;
      var MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      var label = function (s) {
        if (!s) return null;
        var p = s.periodStart ? String(s.periodStart).split("-") : null;
        if (p && p.length === 3) {
          var mi = parseInt(p[1], 10) - 1;
          if (mi >= 0 && mi < 12) return MONTHS[mi] + " " + p[2];
        }
        if (s.month && s.year) {
          var mj = parseInt(s.month, 10) - 1;
          if (mj >= 0 && mj < 12) return MONTHS[mj] + " " + s.year;
        }
        return null;
      };
      var setHeader = function (value, text) {
        var h = self.headers.filter(function (x) { return x.value === value; })[0];
        if (h && text) h.text = text;
      };
      getEstateArpu().then(function (d) {
        var s = d.summaries || [];
        var c = label(s[0]);
        var p = label(s[1]);
        setHeader("arpu", c ? "ARPU (" + c + ")" : null);
        setHeader("lastMonthArpu", p ? "ARPU (" + p + ")" : null);
        var map = {};
        (d.rows || []).forEach(function (row) { map[row.id] = row; });
        self.arpuByNetworkId = map;
      }).catch(function () { self.arpuByNetworkId = {}; });
    },
     fetchRegions(){
      Api().get('/region').then(response=>{
        this.regions=response.data
      })
    },
    
    fetchLocationNetworks() {           
      this.loadingNetwork = true,
      Api()
        .get("/locationnetworks/basic/active")
        .then(response => {

          this.locationNetworks = response.data;
          console.log('networks', response.data)
       this.loadingNetwork = false
        });
    },
    fetchLocationNodes() {
      Api()
        .get("/locationnodes/active")
        .then(response => {
          this.locationNodes = response.data;
        });
    },

    async routerLinkToDetails(item) { 
      this.loadingNetwork=true
      this.editedIndex = this.locationNetworks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$router.push({ path: "/locationNetworks/" + this.editedItem.id });
    },
    getAssociatedNetwork(item) {
      this.editedIndex = this.locationNetworks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      return this.editedItem.LocationNode.name;
    },
    getLocations(item) {
      this.editedIndex = this.locationNetworks.indexOf(item);
      this.locationNodeId = this.locationNetworks.id;
      this.editedItem = Object.assign({}, item);
      Api()
        .get("/locationNetworks/" + this.editedItem.id)
        .then(response => {
          this.locationNetworks = response.data;
  
        });
    },
    

    initialize() {
      // this.fetchLocationNetworks();
      this.fetchLocationNodes();
      this.fetchRegions()
      // this.fetchAllPackageCategories();
    },
    addItem(){
      if(this.authCreate(this.$store.state.currentRoute)){
        this.editedItem.country = "South Africa"
         this.addressinfo = {
           isMDU: false
         }
      this.basicInformation=true;this.dataServices=false;this.tvServices=false; this.address=false; this.newDialog=true,this.fetchAllPackageCategories()
      }
    },
    editItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      this.editedIndex = this.locationNetworks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.basicInformation = true;}
    },

    deleteItem(item) {
      if(this.authDelete(this.$store.state.currentRoute)){
      this.editedItem = Object.assign({}, item);
      confirm("Are you sure you want to delete this item?") &&
      Api().delete("/locationnetworks/" + this.editedItem.id)
      .then(response => {
        this.$emit("locationNetworkSaved");
      })
      }
    },

    close() {
      this.dialog = false;
      this.newDialog = false;
      this.basicInformation = false;
      this.dataServices = false;
      this.tvServices = false;
      this.internetPackages = false;
      this.fnoPackages = false;
      this.generatePackagesModal = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
       let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a network name.");
      }
      if (this.editedItem.locationNodeId == null || this.editedItem.locationNodeId =="") {
        proceed = false;
        confirm("Please select an associated network node.");
      }
       if (this.editedItem.networkStatus == "") {
        proceed = false;
        confirm("Please select a network installation status.");
      }
      if (this.editedItem.streetName == "") {
        proceed = false;
        confirm("Please fill in a street name.");
      }
      if (this.editedItem.country == "") {
        proceed = false;
        confirm("Please fill in the country.");
      }
      if(this.editedItem.lineRentalIncluded == true && (this.editedItem.residentialLineRentalValue == null || this.editedItem.residentialLineRentalValue == "") ) {
        proceed = false;
        confirm("Please fill in the BAS amount (excl. VAT).");
      }
      if (proceed == true) {
      if (!this.editedItem.activationFee) {
        this.editedItem.activationFeeAmount = 0;
        this.editedItem.activationFee = false;
      }
      if (!this.editedItem.tvOverFibre) {
        this.editedItem.tvOverFibre = false;
        this.editedItem.gtuIncluded = false;
        this.editedItem.gtuFee = 0;
      }
      if (!this.editedItem.gtuIncluded) {
        this.editedItem.gtuIncluded = false;
        this.editedItem.gtuFee = 0;
      }
      if (!this.editedItem.routerInstallationFee) {
        this.editedItem.routerInstallationFee = false;
        this.editedItem.routerInstallationFeeAmount = 0;
      }
      if (!this.editedItem.lineRentalIncluded) {
        this.editedItem.lineRentalIncluded = false;
      }
      if (!this.editedItem.geoLongitude) {
        this.editedItem.geoLongitude = "0";
      }
      if (!this.editedItem.geoLatitude) {
        this.editedItem.geoLatitude = "0";
      }
      if (!this.editedItem.geoHightAboveGroundLevel) {
        this.editedItem.geoHightAboveGroundLevel = 0;
      }
      Api().put("/locationnetworks/" + this.editedItem.id, {
        name: this.editedItem.name,
        locationNodeId: this.editedItem.locationNodeId,
        lineRentalIncluded: this.editedItem.lineRentalIncluded,
        businessLineRentalValue: this.editedItem.businessLineRentalValue,
        residentialLineRentalValue: this.editedItem.residentialLineRentalValue,
        tvOverFibre: this.editedItem.tvOverFibre,
        gtuIncluded: this.editedItem.gtuIncluded,
        gtuFee: this.editedItem.gtuFee,
        activationFee: this.editedItem.activationFee,
        activationFeeAmount: this.editedItem.activationFeeAmount,
        routerInstallationFee: this.editedItem.routerInstallationFee,
        residentialRouterInstallationFeeAmount: this.editedItem
            .residentialRouterInstallationFeeAmount,
            businessRouterInstallationFeeAmount: this.editedItem
            .businessRouterInstallationFeeAmount,
        networkStatus: this.editedItem.networkStatus,
        streetNumber: this.editedItem.streetNumber,
        streetName: this.editedItem.streetName,
        suburb: this.editedItem.suburb,
        town: this.editedItem.town,
        city: this.editedItem.city,
        country: this.editedItem.country,
        geoLongitude: this.editedItem.geoLongitude,
        geoLatitude: this.editedItem.geoLatitude,
        geoHightAboveGroundLevel: this.editedItem.geoHightAboveGroundLevel
      }).then(response => {
      this.$emit("locationNetworkSaved");
      })
      this.close();
      this.text = "Network Changes Saved!";
      this.snackbar = true;
    }
  },
      saveNew() {
      let proceed = true;
      if (this.addressinfo.name == "") {
        proceed = false;
        confirm("Please fill in a network name.");
      }
      if (this.addressinfo.locationNodeId == null) {
        proceed = false;
        confirm("Please select an associated network node.");
      }
       if (this.addressinfo.regionId== null) {
        proceed = false;
        confirm("Please select a region.");
      }
       if (this.addressinfo.networkStatus == "") {
        proceed = false;
        confirm("Please select a network installation status.");
      }
      if (this.addressinfo.backhaulType == "") {
        proceed = false;
        confirm("Please select a network backhaul type.");
      }
      if (proceed == true) {
      if (!this.addressinfo.activationFee) {
        this.addressinfo.activationFeeAmount = 0;
        this.addressinfo.activationFee = false;
      }
      if (!this.addressinfo.tvOverFibre) {
        this.addressinfo.tvOverFibre = false;
        this.addressinfo.gtuIncluded = false;
        this.addressinfo.gtuFee = 0;
      }
      if (!this.addressinfo.gtuIncluded) {
        this.addressinfo.gtuIncluded = false;
        this.addressinfo.gtuFee = 0;
      }
      if (!this.addressinfo.routerInstallationFee) {
        this.addressinfo.routerInstallationFee = false;
        this.addressinfo.routerInstallationFeeAmount = 0;
      }
      if (!this.addressinfo.lineRentalIncluded) {
        this.addressinfo.lineRentalIncluded = false;
      }
      if (!this.addressinfo.geoLongitude) {
        this.addressinfo.geoLongitude = "0";
      }
      if (!this.addressinfo.geoLatitude) {
        this.addressinfo.geoLatitude = "0";
      }
      if (!this.addressinfo.geoHightAboveGroundLevel) {
        this.addressinfo.geoHightAboveGroundLevel = 0;
      }
      Api()
        .post("/locationnetworks", {
          name: this.addressinfo.name,
          abbreviation: this.addressinfo.abbreviation,
          locationNodeId: this.addressinfo.locationNodeId,
          networkStatus: this.addressinfo.networkStatus,
          lineRentalIncluded: this.addressinfo.lineRentalIncluded,
          residentialLineRentalValue: this.addressinfo.residentialLineRentalValue,
          businessLineRentalValue: this.addressinfo.businessLineRentalValue,
          tvOverFibre: this.addressinfo.tvOverFibre,
          gtuIncluded: this.addressinfo.gtuIncluded,
          gtuFee: this.addressinfo.gtuFee,
          activationFee: this.addressinfo.activationFee,
          activationFeeAmount: this.addressinfo.activationFeeAmount,
          routerInstallationFee: this.addressinfo.routerInstallationFee,
          residentialRouterInstallationFeeAmount: this.addressinfo
            .residentialRouterInstallationFeeAmount,
            businessRouterInstallationFeeAmount: this.addressinfo
            .businessRouterInstallationFeeAmount,
          streetNumber: this.addressinfo.streetNumber,
          streetName: this.addressinfo.streetName,
          suburb: this.addressinfo.suburb,
          town: this.addressinfo.town,
          city: this.addressinfo.city,
          country: this.addressinfo.country,
          geoLongitude: this.addressinfo.geoLongitude,
          geoLatitude: this.addressinfo.geoLatitude,
          geoHightAboveGroundLevel: this.addressinfo.geoHightAboveGroundLevel,
          backhaulType: this.addressinfo.backhaulType,
          regionId: this.addressinfo.regionId,
          isMDU: this.addressinfo.isMDU,

        })
        .then(response => {
          this.addressinfo.locationNetworkId = response.data.id;
          
          this.id = response.data.id;          
          this.$emit("locationNetworkSaved");          
          this.initialize();
          this.text = "Network Successfully Saved!";
          this.snackbar = true;
        });
      this.close();
      
    }
    }
  }
};
</script>
<style>
.v-chip.Active {
  background: #1ebb2c;
}
.v-chip.Inactive {
  background: #f0121e;
}
.v-chip.Live {
  background: #1ebb2c;
}
.v-chip.Progress {
  background: #df5f09;
}
.v-chip.planned {
  background: #0580e6;
}
.v-chip.activationFee {
  background: #0fc5f3;
}
.v-chip.tvOverFibre {
  background: #b8c417;
}
.v-chip.gtuIncluded {
  background: #dfc013;
}
</style>
